import React, { ReactNode } from 'react'
import FeatureDialog from 'stories/elements/Modal/DialogWindow/FeatureDialog'
import _useTranslation from 'lib/hooks/_useTranslation'

interface Props {
    open: boolean
    handleClose: () => void
    children?: ReactNode
    title?: string
    backgroundColor?: string
    isDarkTheme?: boolean
    headerColor?: string
}

const GradeSelectionDialog = ({ open, handleClose, children, title, backgroundColor, isDarkTheme, headerColor }: Props) => {
    const { t } = _useTranslation('knows')

    return (
        <FeatureDialog
            open={open}
            ariaPrefix="grade-selection"
            title={title ?? t('knows/createDetailsGradeSelectionDialogChooseGrade')}
            onClose={handleClose}
            allowVerticalOverflow
            backgroundColor={backgroundColor}
            isDarkTheme={isDarkTheme}
            headerColor={headerColor}
        >
            {children}
        </FeatureDialog>
    )
}

export default GradeSelectionDialog
